"use strict"
const moment = require('moment/moment');
const format = require("../../helpers/format");
const array_api_inputs = (inputs, data) => {
    let params = [];
    let errors = {};
    let aux = inputs.filter(input => input.name === 'write_nulls');
    let validateNulls = aux.length > 0 ? parseInt(aux[0].write_nulls) : 1;

    for (let input of inputs) {
        let value = data[input.name] !== undefined ? format(input.type, data[input.name], input.format ? input.format : null) : null;
        let err = validateNulls == 1 ? validate(value, input) : [];
        if (typeof value === 'string' && value === "") value = null;
        if (err.length > 0) {
            errors[input.name] = err;
        } else {
            params.push(value);
        }
    }
    if (Object.entries(errors).length === 0) {
        return (params);
    } else {
        throw errors;
    }
}

const validate = (data, rules) => {
    let errors = [];
    let dataType = typeof data;
    if (rules.required) {
        if (data == null || dataType === 'undefined' || data.length == 0) {
            errors.push('this value is required');
        }
    }
    if (rules.type) {
        let ruleType = rules.type;
        if (ruleType.toUpperCase().trim() !== dataType.toUpperCase()) {
            if (ruleType.toUpperCase().trim() == 'CHAR' || ruleType.toUpperCase().trim() == 'VARCHAR' || ruleType.toUpperCase().trim() == 'TEXT') {
                if (dataType !== 'string') {
                    if ((data === null || data == undefined) && !rules.required) {} else { errors.push(`Invalid Type Must be a ${ruleType}`); }
                }
            } else if (ruleType.toUpperCase().trim() == 'DECIMAL' || ruleType.toUpperCase().trim() == 'FLOAT' || ruleType.toUpperCase().trim() == 'NUMBER') {
                if (isNaN(data) || typeof data != 'number') {
                    if ((data === null || data == undefined) && !rules.required) {} else { errors.push(`Invalid Type Must be a ${ruleType}`); }
                }
            } else if (ruleType.toUpperCase().trim() == 'INT' || ruleType.toUpperCase().trim() == 'INTEGER') {
                if (isNaN(data) || typeof data != 'number' || data !== parseInt(data, 10)) {
                    if ((data === null || data == undefined) && !rules.required) {} else { errors.push(`Invalid Type Must be a ${ruleType}`); }
                }
            } else if (ruleType.toUpperCase().trim() == 'ARRAY') {
                if (!Array.isArray(data)) {
                    if ((data === null || data == undefined) && !rules.required) {} else { errors.push(`Invalid Type Must be a ${ruleType}`); }
                }
            } else if (ruleType.toUpperCase().trim() == 'DATE' || ruleType.toUpperCase().trim() == 'DATETIME' || ruleType.toUpperCase().trim() == 'TIMESTAMP') {
                let date = moment(data);
                if (!date || !date.isValid()) {
                    if ((data === null || data == undefined) && !rules.required) {} else { errors.push(`Invalid Type Must be a ${ruleType}`); }
                }
            } else if (ruleType.toUpperCase().trim() == 'BIT') {
                if (isNaN(data) || typeof data != 'number' || data > 1 || data < 0) {
                    if ((data === null || data == undefined) && !rules.required) {} else { errors.push(`Invalid Type Must be a ${ruleType} 1 or 0`); }
                }
            } else {
                if ((data === null || data == undefined) && !rules.required) {} else { errors.push(`Invalid Type Must be a ${ruleType}`); }
            }
        }
    }
    return errors
}

module.exports = array_api_inputs;